import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@app/ui/sports-components/utils/classNames';
import Tooltip from '@app/ui/sports-components/Tooltip';

import { RELO_LOGO } from '../constants/config';

const RHCard = ({
    rightsholder,
    currentRightsholderId,
    selectRightsholder,
}) => {
    const isSelected = currentRightsholderId === rightsholder.id;

    const hotkeyClasses = classNames(
        'gds-hotkey-toggle',
        'gds-hotkey-toggle--sm',
        '-text-center',
        {
            'gds-hotkey-toggle--active': isSelected,
        },
    );

    const _onClick = () => {
        selectRightsholder(rightsholder.id);
    };
    const logoUrl = rightsholder.mainLogo
        ? rightsholder.mainLogo.url
        : RELO_LOGO;

    return (
        <div
            key={rightsholder.id}
            className="onboarding-rightsholder gds-flex__item gds-flex__item--grow-0 -m-r-1"
        >
            <div className={hotkeyClasses} onClick={_onClick}>
                <div className="gds-rightsholder__logo">
                    <img
                        src={logoUrl}
                        height="100%"
                        width="100%"
                        alt={rightsholder.name}
                    />
                </div>
                <Tooltip text={rightsholder.name} position="top-right">
                    <p
                        className="gds-text--body-sm -p-v-1 -ellipsis -text-center"
                        style={{ width: '100px', maxWidth: '100px' }}
                    >
                        {rightsholder.name}
                    </p>
                </Tooltip>
            </div>
        </div>
    );
};

RHCard.propTypes = {
    rightsholder: PropTypes.object.isRequired,
    currentRightsholderId: PropTypes.number,
    selectRightsholder: PropTypes.func,
};

export default RHCard;
